import { Component } from '@angular/core';
import { correctHeight, detectBody } from './app.helpers';
import {Router, NavigationEnd} from "@angular/router";
import { GoogleAnalyticsEventsService } from './google-analytics-events.service';

declare var jQuery:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  ngAfterViewInit() {
    /*jQuery(window).on("load resize", function() {
      correctHeight();
      detectBody();
    });*/
    /*jQuery('.metismenu a').click(function() {
      setTimeout(() => {
        correctHeight();
      }, 300)
    });*/
  }
  constructor(public router: Router, public googleAnalyticsEventsService: GoogleAnalyticsEventsService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ga('set', 'page', event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/app.component.ts